import { render } from "./IziButton.vue?vue&type=template&id=5f9d1b92&scoped=true"
import script from "./IziButton.vue?vue&type=script&lang=ts"
export * from "./IziButton.vue?vue&type=script&lang=ts"

import "./IziButton.vue?vue&type=style&index=0&id=5f9d1b92&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f9d1b92"

export default script